import useShop from "@dashboard/hooks/useShop";
import React from "react";
import { Helmet } from "react-helmet";

interface WindowTitleProps {
  title: string;
}

export const WindowTitle: React.FC<WindowTitleProps> = ({ title }) => {
  const shop = useShop();
  const rawShopName = shop?.name;
  const shopName = !rawShopName || /saleor/i.test(rawShopName) ? "Kisanbasket" : rawShopName;

  return !title ? null : <Helmet title={`${title} | ${shopName}`} />;
};
